let overlayInstance = null;
const clickThroughElements = new Set();

const Overlay = {
    show(options = {}) {
        if (!overlayInstance) {
            overlayInstance = document.createElement('div');
            overlayInstance.id = 'global-overlay';
            Object.assign(overlayInstance.style, {
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                backgroundColor: options.color || 'rgba(128, 128, 128, 0.5)',
               
                zIndex: 2147483646, 
                pointerEvents: 'auto'
            });

            overlayInstance.addEventListener('click', (e) => {
                const isInDialog = Array.from(clickThroughElements).some(el =>
                    el.contains(e.target)
                );

                if (!isInDialog && options.onBackgroundClick) {
                    options.onBackgroundClick(e);
                }
            });

            document.body.appendChild(overlayInstance);
        }
        return overlayInstance;
    },

    hide() {
        if (overlayInstance) {
            document.body.removeChild(overlayInstance);
            overlayInstance = null;
            clickThroughElements.clear();
        }
    },

    registerInteractiveElement(el) {
        if (el) {
            const style = getComputedStyle(el);
           
            if (style.position === 'static') {
                el.style.position = 'relative';
            }
            clickThroughElements.add(el);
            el.style.pointerEvents = 'auto';
            el.style.zIndex = '2147483647'; 
        }
    }
};

const overlayDirective = {
    inserted(el, binding) {
        Overlay.registerInteractiveElement(el);

        el.__clickHandler__ = e => {
            if (binding.value) binding.value(e);
            e.stopPropagation();
        };
        el.addEventListener('click', el.__clickHandler__);
    },
    unbind(el) {
        el.removeEventListener('click', el.__clickHandler__);
        clickThroughElements.delete(el);
        
    }
};

export { Overlay, overlayDirective };